export function SelectChoice(element){
    element.classList.remove("buttonGeneral-devis");
    element.classList.add("activeButton");
}

export function UnselectChoice(element){
    element.classList.remove("activeButton");
    element.classList.add("buttonGeneral-devis");
}
